// extracted by mini-css-extract-plugin
export default {"planConnector":"QuotaInsurancePlanStep_planConnector__soxIG","planConnectorIcon":"QuotaInsurancePlanStep_planConnectorIcon__kZIDK"};